"use client";
import SwappingText from '@components/SwappingText';
import SignUpForm from '@components/SignUpForm'
import { motion } from "motion/react";
import React from "react";
import { AuroraBackground } from './AuroraBackground'
import { useMediaQuery } from '@mantine/hooks';

const BannerModal = () => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  
  if (isMobile) return (
    <div className='flex h-[70vh] flex-col items-center justify-center bg-white text-slate-950'>
      <div
        className="md:w-8/12 w-full mx-auto relative flex flex-col gap-4 items-center justify-start px-4"
      >
            <div className='w-full flex flex-col items-start justify-end md:gap-6 gap-3 select-none'>
              <h1 className='md:text-6xl text-2xl z-30 welist-title select-none'>AI-Powered Solutions for</h1>
              <div className='flex flex-row mb-2'>
                <h2 className='md:text-6xl text-2xl p-0 md:mr-4 mr-2 welist-title select-none'>Real Estate </h2><SwappingText />
              </div>
              <span className='text-xl text-gray-500'>Website and Social Marketing with AI-supported backend <span className='underline decoration-[#01959C] underline-offset-4'>out of the box.</span></span>
              <SignUpForm title='Learn More' size='lg' formType='banner' />
            </div>
      </div>
    </div>
  )

  return (
    <AuroraBackground>
      <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="md:w-8/12 w-full mx-auto relative flex flex-col gap-4 items-center justify-start px-4"
      >
            <div className='w-full flex flex-col items-start justify-end md:gap-6 gap-3 select-none'>
              <h1 className='md:text-6xl text-2xl z-30 welist-title select-none'>AI-Powered Solutions for</h1>
              <div className='flex flex-row mb-2'>
                <h2 className='md:text-6xl text-2xl p-0 md:mr-4 mr-2 welist-title select-none'>Real Estate </h2><SwappingText />
              </div>
              <span className='text-xl text-gray-500'>Website and Social Marketing with AI-supported backend <span className='underline decoration-[#01959C] underline-offset-4'>out of the box.</span></span>
              <SignUpForm title='Learn More' size='lg' formType='banner' />
            </div>
      </motion.div>
    </AuroraBackground>
  )
}

export default BannerModal